import { type MutationHookOptions, useMutation } from "@apollo/client";
import { ReconcileRefundMutation } from "../graphql/mutations";
import type {
  ReconcileRefundMutationType,
  ReconcileRefundMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useReconcileRefundMutation = (
  options?: MutationHookOptions<
    ReconcileRefundMutationType,
    ReconcileRefundMutationVariablesType
  >
) =>
  useMutation<
    ReconcileRefundMutationType,
    ReconcileRefundMutationVariablesType
  >(ReconcileRefundMutation, options);
